import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { ChevronRight } from "lucide-react";

export default function AdminUsers() {
  const { t } = useI18n();
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");

  const load = () => api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const filtered = users.filter((u) => {
    if (roleFilter !== "all" && u.role !== roleFilter) return false;
    if (!filter) return true;
    const q = filter.toLowerCase();
    return u.email.toLowerCase().includes(q) || u.name.toLowerCase().includes(q);
  });

  const roles = ["all", "customer", "artist", "referrer", "admin"];
  const roleCount = (r) => r === "all" ? users.length : users.filter((u) => u.role === r).length;

  return (
    <div data-testid="admin-users">
      <h1 className="font-serif text-4xl font-light tracking-tight mb-2">{t.adminUsers.title}</h1>
      <p className="text-sm text-neutral-500 mb-6">{t.adminUsers.subtitle} · Haz click en un usuario para ver su dashboard.</p>

      <div className="flex flex-wrap gap-3 mb-4">
        <input
          placeholder={t.adminUsers.search}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border border-neutral-300 px-4 py-2 text-sm bg-white w-full sm:w-80"
          data-testid="users-search"
        />
        <div className="flex gap-1 flex-wrap">
          {roles.map((r) => (
            <button
              key={r}
              onClick={() => setRoleFilter(r)}
              className={`overline text-xs px-3 py-2 border ${roleFilter === r ? "bg-black text-white border-black" : "border-neutral-300 hover:bg-neutral-50"}`}
              data-testid={`role-filter-${r}`}
            >
              {r === "all" ? "Todos" : r} ({roleCount(r)})
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white border border-neutral-200 overflow-x-auto">
        <table className="brutal-table w-full">
          <thead>
            <tr>
              <th>{t.adminUsers.name}</th>
              <th>Email</th>
              <th>{t.adminUsers.role}</th>
              <th>Estado</th>
              <th>{t.adminUsers.created}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`} className="hover:bg-neutral-50 cursor-pointer">
                <td className="font-medium">
                  <Link to={`/admin/users/${u.user_id}`} className="block hover:underline" data-testid={`user-link-${u.user_id}`}>{u.name}</Link>
                </td>
                <td className="text-neutral-500 text-xs">
                  <Link to={`/admin/users/${u.user_id}`} className="block">{u.email}</Link>
                </td>
                <td>
                  <Link to={`/admin/users/${u.user_id}`} className="overline text-[10px] px-2 py-1 border border-neutral-200 bg-neutral-50 inline-block">{u.role}</Link>
                </td>
                <td>
                  {u.disabled ? (
                    <span className="overline text-[10px] px-2 py-1 border border-red-200 bg-red-50 text-red-700">Deshabilitado</span>
                  ) : (
                    <span className="overline text-[10px] px-2 py-1 border border-emerald-200 bg-emerald-50 text-emerald-700">Activo</span>
                  )}
                </td>
                <td className="text-xs text-neutral-500">{new Date(u.created_at).toLocaleDateString()}</td>
                <td className="text-right">
                  <Link to={`/admin/users/${u.user_id}`} className="inline-flex items-center text-neutral-400 hover:text-black"><ChevronRight size={16} /></Link>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="6" className="text-center py-12 overline text-neutral-400">—</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
